import PropTypes from 'prop-types';
import React from 'react';

import { LoaderWrapper } from '../form-preview.styled';

const Loader = ({ text = 'Loading...please wait!' }) => (
  <LoaderWrapper>
		<svg width="42" height="42" viewBox="0 0 38 38" xmlns="http://www.w3.org/2000/svg">
			<g fill="none" fillRule="evenodd">
				<g transform="translate(1 1)" strokeWidth="2">
					<circle strokeOpacity=".2" cx="18" cy="18" r="18" />
					<path d="M36 18c0-9.94-8.06-18-18-18">
						<animateTransform
							attributeName="transform"
							repeatCount="indefinite"
							to="360 18 18"
							from="0 18 18"
							type="rotate"
							dur=".7s"
						/>
					</path>
				</g>
			</g>
		</svg>

		{text}
	</LoaderWrapper>
);

Loader.propTypes = {
	text: PropTypes.string.isRequired
};

export default Loader;